import { message } from 'antd'
import { resetMyPassword, resetUserPassword } from '../../../HttpRequests/users'

export default (id, values) => async () => {
    
  const data = {
    password: values.password,
    force_reset_on_login: values.force_reset_on_login || false,
  }

  if (id) {

    await resetUserPassword({ id, data })

  } else {

    await resetMyPassword({ data })
    
    // Update the local user state to reflect that password reset is no longer required
    if (window.state && window.state.user) {
      window.state.user.reset_password = false
    }

  }

  message.success('Password reset')

}
